/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';
import parserActions from 'loraactions/parser';
import ParserCard from '../ParserCard';
import ParserAddCard from '../ParserAddCard';
import ParserLoadingCard from '../ParserLoadingCard';
import styles from './styles.scss';

const propTypes = {
  parsers: React.PropTypes.object.isRequired,
  appId: React.PropTypes.string.isRequired,
  getParsers: React.PropTypes.func.isRequired,
};

class Parsers extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      parsers: props.parsers,
    };
  }

  componentWillMount() {
    const { appId, getParsers } = this.props;
    getParsers({ appid: appId });
  }

  componentWillReceiveProps(nextProps) {
    const { parsers } = nextProps;
    if (parsers !== this.props.parsers) {
      this.setState({ parsers });
    }
  }

  render() {
    const { appId } = this.props;
    const { parsers } = this.state;

    let parserCards;

    if (parsers.status === 'success') {
      parserCards = parsers.data.list.map(p => (
        <Col key={p.id} md={3} className="collapse-left">
          <ParserCard parser={p} appId={appId} />
        </Col>
      ));
    } else if (parsers.status === 'pending') {
      parserCards = (
        <Col md={3} className="collapse-left">
          <ParserLoadingCard />
        </Col>
      );
    }

    return (
      <div className={styles.parsers}>
        <Grid fluid>
          <Row>
            {parserCards}
            <Col md={3} className="collapse-left">
              <ParserAddCard appId={appId} />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

Parsers.propTypes = propTypes;

const mapStateToProps = state => ({
  parsers: state.parser.getParsers,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getParsers: parserActions.getParsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(Parsers);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/Parsers/index.jsx